<template>
  <section id="targetAdmin" class="pa-0">
    <div
      @click="redirect(region.value)"
      v-for="(region, index) in regions"
      :style="{
        backgroundColor: region.color,
      }"
      :key="index"
      class="place-center white--text text-h5 font-weight-bold"
    >
      {{ region.title }}
    </div>
    <div
      id="all"
      @click="redirect('')"
      class="place-center white--text text-h5 font-weight-bold"
    >
      全国
    </div>
  </section>
</template>

<script>
export default {
  name: "TargetForAdmin",
  data() {
    return {
      regions: [
        {
          title: "华东区域",
          value: "2",
          color: "#9E2896",
        },
        {
          title: "华中区域",
          value: "6",
          color: "#551151",
        },
        {
          title: "湖北区域",
          value: "7",
          color: "#56B0FF",
        },
        {
          title: "西南区域",
          value: "5",
          color: "#006EAD",
        },
        {
          title: "华北区域",
          value: "1",
          color: "#00884A",
        },
        {
          title: "西北区域",
          value: "3",
          color: "#79C5C0",
        },
      ],
    };
  },
  methods: {
    redirect(region) {
      this.$router.push({
        path: "/target",
        query: {
          region,
        },
      });
    },
  },
};
</script>

<style lang="sass">
#targetAdmin
  display: grid
  grid-template-columns: repeat(2, 1fr)
  grid-template-rows: repeat(4, 1fr)
  height: calc(100% - 48px)
  width: 100%
  &>div
    letter-spacing: 1px
  #all
    grid-column: 1/3
    background-color: #AF2024
</style>
